module.exports = __webpack_public_path__ + "static/img/emergancyBeg.4836e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emergancyBeg.png
// module id = SAgd
// module chunks = 21